var map = {
	"./auth.json": "../../packages/i18n/src/uk/auth.json",
	"./banners.json": "../../packages/i18n/src/uk/banners.json",
	"./business-meta.json": "../../packages/i18n/src/uk/business-meta.json",
	"./chat/common.json": "../../packages/i18n/src/uk/chat/common.json",
	"./chat/list.json": "../../packages/i18n/src/uk/chat/list.json",
	"./chat/message.json": "../../packages/i18n/src/uk/chat/message.json",
	"./company/admin.json": "../../packages/i18n/src/uk/company/admin.json",
	"./company/common.json": "../../packages/i18n/src/uk/company/common.json",
	"./company/create.json": "../../packages/i18n/src/uk/company/create.json",
	"./company/options.json": "../../packages/i18n/src/uk/company/options.json",
	"./company/page.json": "../../packages/i18n/src/uk/company/page.json",
	"./company/users.json": "../../packages/i18n/src/uk/company/users.json",
	"./errors.json": "../../packages/i18n/src/uk/errors.json",
	"./group-preview.json": "../../packages/i18n/src/uk/group-preview.json",
	"./landing/companies.json": "../../packages/i18n/src/uk/landing/companies.json",
	"./landing/driver.json": "../../packages/i18n/src/uk/landing/driver.json",
	"./landing/exchange.json": "../../packages/i18n/src/uk/landing/exchange.json",
	"./landing/meta.json": "../../packages/i18n/src/uk/landing/meta.json",
	"./landing/private_exchange.json": "../../packages/i18n/src/uk/landing/private_exchange.json",
	"./landing/shared.json": "../../packages/i18n/src/uk/landing/shared.json",
	"./layout.json": "../../packages/i18n/src/uk/layout.json",
	"./modals.json": "../../packages/i18n/src/uk/modals.json",
	"./offer/actions.json": "../../packages/i18n/src/uk/offer/actions.json",
	"./offer/exchange.json": "../../packages/i18n/src/uk/offer/exchange.json",
	"./offer/form/cargo.json": "../../packages/i18n/src/uk/offer/form/cargo.json",
	"./offer/form/common.json": "../../packages/i18n/src/uk/offer/form/common.json",
	"./offer/form/options.json": "../../packages/i18n/src/uk/offer/form/options.json",
	"./offer/form/transport.json": "../../packages/i18n/src/uk/offer/form/transport.json",
	"./offer/matches.json": "../../packages/i18n/src/uk/offer/matches.json",
	"./offer/my.json": "../../packages/i18n/src/uk/offer/my.json",
	"./offer/own.json": "../../packages/i18n/src/uk/offer/own.json",
	"./offer/preview.json": "../../packages/i18n/src/uk/offer/preview.json",
	"./offer/shared.json": "../../packages/i18n/src/uk/offer/shared.json",
	"./offer/view.json": "../../packages/i18n/src/uk/offer/view.json",
	"./placeholders.json": "../../packages/i18n/src/uk/placeholders.json",
	"./profile/black_list.json": "../../packages/i18n/src/uk/profile/black_list.json",
	"./profile/contact_list.json": "../../packages/i18n/src/uk/profile/contact_list.json",
	"./profile/edit_profile.json": "../../packages/i18n/src/uk/profile/edit_profile.json",
	"./profile/fill_profile.json": "../../packages/i18n/src/uk/profile/fill_profile.json",
	"./profile/my_profile.json": "../../packages/i18n/src/uk/profile/my_profile.json",
	"./profile/my_profile_auth.json": "../../packages/i18n/src/uk/profile/my_profile_auth.json",
	"./profile/profile_form.json": "../../packages/i18n/src/uk/profile/profile_form.json",
	"./profile/shared.json": "../../packages/i18n/src/uk/profile/shared.json",
	"./profile/short_profile.json": "../../packages/i18n/src/uk/profile/short_profile.json",
	"./shared.json": "../../packages/i18n/src/uk/shared.json",
	"./ui.json": "../../packages/i18n/src/uk/ui.json",
	"./validation.json": "../../packages/i18n/src/uk/validation.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../../packages/i18n/src/uk sync recursive \\.json$";